
import React, {Component} from 'react';
import JobControlBoardTable from '../workdoc/jobcontrol/JobControlBoardTable';
import PrintPreview from './PrintPreview';
import WorkdocStore from '../../stores/WorkdocStore';
import ReportStore from '../../stores/ReportStore';

const DEFAULT_ROW = 10
class PrintFixingOrderDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initState()
    this.pcInput = new Array(DEFAULT_ROW).fill('')

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
    
  }

  initState(newState) {
    
    let state = {
      loading:false,
      data:this.newEmptyRow(DEFAULT_ROW),
      all_page:[]
    }

    if(newState!==undefined){
      state = Object.assign(state,newState)
    }
    return state
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {list:'',quantity:'',price_per_unit:''}
    })
  }

  componentDidMount(){
    
  }

  renderTable() {
    return (
      <table className='table table-responsive table-hover table-bordered-solid table-print-fixing-order-doc'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>ลำดับ</th>
            <th className='text-center'>รายการค่าแรงซ่อม</th>
            <th className='text-center' style={{width:'70px'}}>จำนวน</th>
            <th className='text-center' style={{width:'120px'}}>ค่าแรง</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        <tfoot>
          <tr >            
            <th className='text-right'></th>
            <th className='text-center'>รวม</th>
            <th className='text-right'></th>
            <th className='text-right'>18,000</th>
        </tr>
        </tfoot>
      </table>
    )
  }

  renderRowData(){
    let {data} = this.state
    
    return data.map((item,index)=>(
      <tr key={index}>
        <td className='text-center'>{index+1}</td>
        <td>        
          
        </td>
        <td  className='text-center'>
          
        </td>
        <td className='text-right'>
          
        </td>
      </tr>
    ))
  }

  render() {
    let {loading} = this.state
    return(
        <div>
          <PrintPreview
            loading={loading}
            size={'portrait'}
            leftBarTitle={'ตารางค่าแรงซ่อม'}
          >
            <div key={0}>
              <div>
                <div className='text-center'>
                  <h4>ตารางค่าแรงซ่อม</h4>
                </div>
              </div>
              <div>
                {this.renderTable()}
              </div>
            </div>
          </PrintPreview> 
        </div>  
    )      
  }

}


export default PrintFixingOrderDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintFixingOrderDoc.js